import React, { useContext } from "react";
import "./CartItems.css";
import cross_icon from "../Assets/cart_cross_icon.png";
import { ShopContext } from "../../Context/ShopContext";
const currency = '₹'
const CartItems = () => {
  const { products, cartItems, removeFromCart, getTotalCartAmount, clearCart } = useContext(ShopContext);

  // Function to handle "Buy Now" button click
  const handleBuyNow = async () => {
    try {
      // Create an array of cart items to send to the backend
      const cartData = products
        .filter(product => cartItems[product.id] > 0)
        .map(product => ({
          productId: product.id,
          quantity: cartItems[product.id]
        }));

      // Send request to the backend with the cart data
      const response = await fetch(`https://freecycle-backend-1.onrender.com/placeorder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': localStorage.getItem('auth-token'), // Fetch the auth token from localStorage
        },
        body: JSON.stringify({ cartData }) // Send the cart items in the request body
      });

      const result = await response.json();

      if (response.ok && result.success) {
        alert('Order confirmed! Check your email.');
        clearCart(); // Optional: Clear cart after successful order
      } else {
        alert(result.message || 'Error placing order');
      }
    } catch (error) {
      console.error('____');
    }
  };

  return (
    <div className="cartitems">
      <div className="cartitems-format-main">
        <p>Products</p>
        <p>Title</p>
        <p>Price</p>
        <p>Quantity</p>
        <p>Total</p>
        <p>Remove</p>
      </div>
      <hr />
      {products.map((e) => {
        if (cartItems[e.id] > 0) {
          return (
            <div key={e.id}> {/* Added unique key here */}
              <div className="cartitems-format-main cartitems-format">
                <img className="cartitems-product-icon" src={e.image} alt={e.name} />
                <p>{e.name}</p> {/* Removed non-boolean attribute `cartitems-product-title` */}
                <p>{currency}{e.new_price}</p>
                <button className="cartitems-quantity">{cartItems[e.id]}</button>
                <p>{currency}{e.new_price * cartItems[e.id]}</p>
                <img
                  onClick={() => { removeFromCart(e.id); }}
                  className="cartitems-remove-icon"
                  src={cross_icon}
                  alt="Remove"
                />
              </div>
              <hr />
            </div>
          );
        }
        return null;
      })}

      <div className="cartitems-down">
        <div className="cartitems-total">
          <h1>Cart Totals</h1>
          <div>
            <div className="cartitems-total-item">
              <p>Subtotal</p>
              <p>{currency}{getTotalCartAmount()}</p>
            </div>
            <hr />
            <div className="cartitems-total-item">
              <p>Shipping Fee</p>
              <p>Free</p>
            </div>
            <hr />
            <div className="cartitems-total-item">
              <h3>Total</h3>
              <h3>{currency}{getTotalCartAmount()}</h3>
            </div>
          </div>
          <button id="buy-now" onClick={handleBuyNow}>BUY NOW</button>
        </div>
      </div>
    </div>
  );
};

export default CartItems;
